import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import SectionHeader from './SectionHeader';
import makerPhoto from '../../../assets/videoWrapperImage.png';

import css from './Sections.module.css';

const FILM_URL = 'https://www.youtube.com/watch?v=SZMR02skj6Q';

/**
 * Maker spotlight: the maker at work, with a button that plays his film in the photo's place,
 * and his story on cream beside it.
 */
function SectionHowItWorks(props) {
  const { intl } = props;
  const [playing, setPlaying] = useState(false);
  const mediaRef = useRef(null);

  // The button goes as the film starts: the keyboard moves on to the film in its place
  useEffect(() => {
    if (playing && mediaRef.current) mediaRef.current.focus();
  }, [playing]);

  return (
    <section className={css.section}>
      <div className={css.container}>
        <div className={css.spotlight}>
          <div className={css.spotlightMedia} ref={mediaRef} tabIndex={-1}>
            {playing ? (
              <ReactPlayer url={FILM_URL} playing controls width="100%" height="100%" />
            ) : (
              <>
                <img
                  className={css.spotlightImage}
                  src={makerPhoto}
                  alt={intl.formatMessage({ id: 'SectionHowItWorks.imageAlt' })}
                />
                <button
                  type="button"
                  className={css.watchButton}
                  onClick={() => setPlaying(true)}
                  aria-label={intl.formatMessage({ id: 'SectionHowItWorks.play' })}
                >
                  <span className={css.watchIcon}>
                    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M7 4v16l13-8z" />
                    </svg>
                  </span>
                  <FormattedMessage id="SectionHowItWorks.watch" />
                </button>
              </>
            )}
          </div>
          <div className={css.spotlightText}>
            <SectionHeader
              eyebrow={intl.formatMessage({ id: 'SectionHowItWorks.eyebrow' })}
              title={intl.formatMessage({ id: 'SectionHowItWorks.title' })}
              className={css.spotlightTitle}
            />
            <p className={css.spotlightFacts}>
              <FormattedMessage id="SectionHowItWorks.facts" />
            </p>
            <p className={css.spotlightBody}>
              <FormattedMessage id="SectionHowItWorks.description" />
            </p>
            <NamedLink
              className={css.buttonPrimary}
              name="ProfilePage"
              params={{ username: 'ellisflutes' }}
            >
              <FormattedMessage id="SectionHowItWorks.visitShop" />
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                aria-hidden="true"
              >
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </NamedLink>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionHowItWorks;
